<div class="table-wrap">
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Rang</th>
        <th scope="col">Agent</th>
        <th scope="col" class="table__num">Élim.</th>
        <th scope="col">{{ lastColumn() === 'status' ? 'Statut' : 'Éliminé par' }}</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track row.codeName) {
        @let self = row.codeName === selfCodeName();
        <tr [class.table__row--out]="isOut(row)" [class.table__row--self]="self">
          <td>{{ digits(row.rank) }}</td>
          <td>
            <span class="table__agent">
              <img
                [src]="isOut(row) ? '/assets/silhouette-out.svg' : '/assets/silhouette.svg'"
                alt=""
              />
              <span
                >{{ row.codeName }}
                @if (self) {
                  (vous)
                }
                <span class="first-name">{{ row.firstName }}</span>
              </span>
            </span>
          </td>
          <td class="table__num">{{ row.score }}</td>
          <td>
            @if (lastColumn() === 'eliminatedBy' && row.eliminatedBy) {
              {{ row.eliminatedBy }}
            } @else {
              <span class="badge" [class]="badge(row.statusCode)">{{ label(row) }}</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
